<template>
  <div class="page-container" :class="{ 'page-container--with-sidebar': isSidebarPresent }">
    <div class="admin__header">
      <h1 class="page-title">Uredi Promocijsko kodo</h1>
      <v-button class="delete-button" :disabled="isLoading" @click="onDelete" background-color="red" outlined>Izbriši</v-button>
    </div>
    <promotion-code-form v-show="!isLoading" @submit="submitPromotionCode" @delete="onDelete" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PromotionCodeForm from './forms/PromotionCodeForm'
import VButton from 'design-system/VButton.vue'
import prompt from 'design-system/components/prompt/prompt'

export default {
  props: {
    id: { type: [String, Number], required: true },
  },
  components: {
    PromotionCodeForm,
    VButton,
  },
  created () {
    this.initialize(this.id)
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapState(['isLoading']),
  },
  methods: {
    ...mapActions('admin/promotionCodes/forms', ['initialize', 'reset', 'submitPromotionCode', 'deletePromotionCode']),
    async onDelete () {
      const result = await prompt.okText('Izbriši').confirm('Res želite izbrisati promocijsko kodo?')
      if (result) {
        this.deletePromotionCode(this.id).then(() => this.$router.push({ name: 'admin_promotion_codes_path' }))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/admin_common';
@import '@/components/common';
</style>
